import {StyleSheet} from 'react-native';

// Theme-aware styles factory (the makeStyles pattern — docs/DARK-MODE.md):
// consumed via useThemedStyles(makeStyles) so colors re-resolve on theme
// change instead of baking at module load.
const makeStyles = colors =>
  StyleSheet.create({
    topRow: {
      flexDirection: 'row',
    },
    bottomRow: {
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'space-between',
      marginTop: 8,
    },
    container: {
      padding: 12,
      backgroundColor: colors.surface,
      marginTop: 16,
      borderRadius: 16,
      shadowRadius: 30,
      shadowColor: colors.shadow,
      shadowOffset: {height: 0, width: 0},
      shadowOpacity: 0.12,
    },
    image: {
      width: 100,
      aspectRatio: 1,
      borderRadius: 8,
      overflow: 'hidden',
    },
    content: {
      marginLeft: 16,
      flex: 1,
      alignItems: 'flex-start',
    },
    tagContainer: {
      padding: 8,
      backgroundColor: colors.backgroundMuted,
      borderRadius: 8,
      marginTop: 10,
    },
    marginRight16: {
      marginRight: 16,
    },
  });

export default makeStyles;
